import ProxyBase from '../../../core/proxies/ProxyBase'

class Proxy extends ProxyBase {
  getCoachMarks(params) {
    return this.get('CoachMark/CoachMarks', params)
  }

  updateCoachMarks(params) {
    return this.post('CoachMark/MarkAsViewed', params)
  }
}

const proxy = new Proxy()
export default proxy
